// Token utility functions for authentication

/**
 * Store token in localStorage
 * @param {string} token - JWT token
 */
export const setToken = (token) => {
  localStorage.setItem('authToken', token);
};

/**
 * Store token in localStorage (alias for setToken)
 * @param {string} token - JWT token
 */
export const saveToken = (token) => {
  localStorage.setItem('authToken', token);
};

/**
 * Get token from localStorage
 * @returns {string|null} - JWT token or null if not found
 */
export const getToken = () => {
  return localStorage.getItem('authToken');
};

/**
 * Remove token from localStorage
 */
export const removeToken = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('superAdminData');
  localStorage.removeItem('isAuthenticated');
  sessionStorage.removeItem('authToken');
  sessionStorage.removeItem('superAdminData');
  sessionStorage.removeItem('isAuthenticated');
};

/**
 * Check if user is authenticated (has valid token)
 * @returns {boolean} - true if authenticated, false otherwise
 */
export const isAuthenticated = () => {
  // Since backend doesn't use JWT, check simple authentication flag
  const authFlag = localStorage.getItem('isAuthenticated') || sessionStorage.getItem('isAuthenticated');
  const superAdminData = localStorage.getItem('superAdminData') || sessionStorage.getItem('superAdminData');
  
  return authFlag === 'true' && superAdminData !== null;
};

/**
 * Get user data from localStorage
 * @returns {object|null} - User data or null if not found
 */
export const getUserFromToken = () => {
  const superAdminData = localStorage.getItem('superAdminData') || sessionStorage.getItem('superAdminData');
  if (!superAdminData) return null;
  
  try {
    return JSON.parse(superAdminData);
  } catch (error) {
    console.error('Error parsing superadmin data:', error);
    return null;
  }
};

/**
 * Get super admin data
 * @returns {object|null} - Super admin data or null if not found
 */
export const getSuperAdminData = () => {
  return getUserFromToken();
};

/**
 * Check if token is about to expire (within 5 minutes)
 * Since we're not using JWT, this always returns false
 * @returns {boolean} - false since we don't have expiring tokens
 */
export const isTokenExpiringSoon = () => {
  return false;
};